import { css } from '@emotion/core';
import { mq } from '../../../cssInJs';

export default {
  photoSlide: css(mq({
    margin: 'auto',
    width: ['90%','70%'] 
  })),
};